import { convertFromRaw, RawDraftContentState } from 'draft-js';
import React, { useMemo } from 'react';
import { BrowserView } from 'react-device-detect';
import { Link } from 'react-router-dom';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Icone from 'Component/Icone';
import UnidadeDeAprendizagem from 'Interface/UnidadesDeAprendizagem';
import { useRemoverUnidadeDeAprendizagemMutation } from 'View/Service/Default/UnidadesDeAprendizagem';

interface Props {
  dados: UnidadeDeAprendizagem;
}

const Lista = ({ dados }: Props): React.ReactElement => {
  const toast = useToast();
  const [removerUnidade] = useRemoverUnidadeDeAprendizagemMutation();

  const remover = async (): Promise<void> => {
    try {
      await removerUnidade({ id: dados.id }).unwrap();

      toast({
        conteudo: 'Removido com sucesso!',
        tema: 'success',
      });
    } catch (erro) {
      toast({
        titulo: 'Erro ao remover',
        conteudo: 'Verifique o registro de log para mais detalhes!',
        tema: 'danger',
      });
    }
  };

  const descricao = useMemo(() => {
    const descricao = convertFromRaw(
      dados.descricao as unknown as RawDraftContentState
    );

    return descricao.getPlainText('\u0001');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="d-flex border-bottom align-items-center py-2 px-3 gap-3">
      <div className="fs-5 text-truncate">
        <Link
          to={`/admin/unidades-de-aprendizagem/editar/${dados.id}`}
          className="text-decoration-none"
        >
          {dados.titulo}
        </Link>
        <small className="d-block fs-6 text-muted text-truncate">
          {descricao}
        </small>
      </div>
      <BrowserView className="d-flex flex-grow-1 align-items-center justify-content-end gap-5">
        <div className="fs-6 text-end text-nowrap">
          {dados.id}
          <small className="d-block fs-6 text-muted">
            <Icone nome="hash" className="me-2" />
            Código
          </small>
        </div>
        <div className="fs-6 text-end text-nowrap">
          {dados.criado.data().toLocaleString()}
          <small className="d-block fs-6 text-muted">
            <Icone nome="calendar" className="me-2" />
            Criado em
          </small>
        </div>
        <div className="fs-5 text-end d-flex gap-2 align-items-center">
          <Botao
            icone="trash"
            tema="danger"
            confirmacao="Você tem certeza que deseja remover esse curso? Essa ação é irreversivel."
            onClick={remover}
          />
        </div>
      </BrowserView>
    </div>
  );
};

export default Lista;
